// extracted by mini-css-extract-plugin
export default {"container":"styles_container__CFwPo","loader":"styles_loader__nUrec","rotation":"styles_rotation__nxbn2","primary":"styles_primary__0+JOq","secondary":"styles_secondary__LPSln"};